import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import config from 'app/requests/Container/Damage.requests'
import {
    Damage,
} from '../Damages/Damages.types'

export default (id: number) => {
    return useRequest<Damage>({
        key: RequestKeys.getDamage,
        params: {
            id,
        },
        requestFunc: RequestFn.getEntity(config.get),
        enabled: Boolean(id),
    })
}
